import React, { Component } from 'react';
import api from '../api';
import { toast } from 'react-toastify';
import store from "../redux/store";
import InvestorsData from '../custom-components/jform/investors-data';
import InvestorsData1 from '../custom-components/jform/investors-data1';
import OtherInfo from '../custom-components/jform/other-info';
import OtherInfo1 from '../custom-components/jform/other-info1';
import NextOfKin from '../custom-components/jform/next-of-kin';
import NextOfKin1 from '../custom-components/jform/next-of-kin1';
import EmploymentDetails from '../custom-components/jform/employment-details';
import EmploymentDetails1 from '../custom-components/jform/employment-details1';
import InvestmentDetails from '../custom-components/jform/investment-details';
import IDMeans from '../custom-components/jform/id-means';
import IDMeans1 from '../custom-components/jform/id-means1';
import BankDetails from '../custom-components/jform/bank-details';
import GuarantorAccount from '../custom-components/jform/guarantor-account';
import Confirmation from '../custom-components/jform/confirmation';
import { Header } from '../custom-components/header';
import loadScripts from '../../dassets/js/custom';

export default class CreateJForms extends Component {
  componentDidMount() {
    loadScripts();
  }
    constructor(props) {
        super(props);

        // this.onChangeFiles = this.onChangeFiles.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.sendJForm = this.sendJForm.bind(this);
        this.saveValues = this.saveValues.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);

        this.state = {
            step: 1
        }

        this.fieldValues = {
            type: "joint",
            investor_data: [
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    marital_status: null,
                    mother_maiden_name: null,
                    id_no: null,
                    phone1: null,
                    phone2: null,
                    signature_path: null,
                    passport_path: null,
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    marital_status: null,
                    mother_maiden_name: null,
                    id_no: null,
                    phone1: null,
                    phone2: null,
                    signature_path: null,
                    passport_path: null,
                }
            ],
            other_info: [
                {
                    residential_add: null,
                    contact_add: null,
                    country: null,
                    nationality: null,
                    state_of_origin: null,
                    city_lga: null,
                },
                {
                    residential_add: null,
                    contact_add: null,
                    country: null,
                    nationality: null,
                    state_of_origin: null,
                    city_lga: null,
                }
            ],
            next_of_kin: [
                {
                    nok_surname: null,
                    nok_first_name: null,
                    nok_other_name: null,
                    nok_relationship: null,
                    nok_contact_add: null,
                    nok_phone: null,
                    nok_email: null,
                },
                {
                    nok_surname: null,
                    nok_first_name: null,
                    nok_other_name: null,
                    nok_relationship: null,
                    nok_contact_add: null,
                    nok_phone: null,
                    nok_email: null,
                }
            ],
            employment_details: [
                {
                    emp_status: null,
                    emp_date: null,
                    emp_name: null,
                    emp_add: null,
                    occupation: null,
                    source_of_income: null,
                    source_of_investment: null,
                    gross_yearly_income: null,
                },
                {
                    emp_status: null,
                    emp_date: null,
                    emp_name: null,
                    emp_add: null,
                    occupation: null,
                    source_of_income: null,
                    source_of_investment: null,
                    gross_yearly_income: null,
                }
            ],
            id_means: [
                {
                    id_type: null,
                    number: null,
                    issue_date: null,
                    expiry_date: null,
                    etcc: null,
                },
                {
                    id_type: null,
                    number: null,
                    issue_date: null,
                    expiry_date: null,
                    etcc: null,
                }
            ],
            bank_name: null,
            acct_name: null,
            acct_no: null,
            acct_type: null,
            opening_date: null,
            bvn: null,
            initial_investment: null,
            mode_of_payment: null,
            mode_of_communication: null,
            investment_objective: null,
            entity_name: null,
            full_name: null,
            identification: null,
            guarantor_dob: null,
            res_reg_add: null,
            prefered_account: null,
            heard_about_us: [],
            kyc_docs: [{ label: "Utility Bill", value: "Utility Bill"}],
            receive_reports: [],
        }
    }

    saveValues(fields, key = null, index = 0) {
        if (!key) {
            this.fieldValues = Object.assign({}, this.fieldValues, fields);
        } else {
            this.fieldValues[key][index] = fields;
        }
    }

    nextStep() {
        this.setState({
            step: this.state.step + 1
        })
    }

    // Same as nextStep, but decrementing
    previousStep() {
        this.setState({
            step: this.state.step - 1
        })
    }

    async onSubmit() {
        let i = 0;
        this.fieldValues.kyc_docs.find(o => {
            if (o.name === 'Utility Bill') {
                i++;
            }
        });

        if(this.fieldValues.kyc_docs.some(r=> ["Driver's Licence","International Passport","National ID Card","Permanent Voters Card"].includes(r.name))){
            i++;
        }

        if (i < 2) {
            toast.error("You need to upload an ID card and Utility Bill");
            return
        }
        
        this.fieldValues.kyc_docs = JSON.stringify(this.fieldValues.kyc_docs);
        this.fieldValues.heard_about_us = this.fieldValues.heard_about_us.toString();
        this.fieldValues.receive_reports = this.fieldValues.receive_reports.toString();

        const formData = new FormData();
        formData.append('file_no', this.fieldValues.documents.length + 4);
        formData.append('file0', this.fieldValues.investor_data[0].passport, this.fieldValues.investor_data[0].passport_path);
        formData.append('file1', this.fieldValues.investor_data[0].signature, this.fieldValues.investor_data[0].signature_path);
        formData.append('file2', this.fieldValues.investor_data[1].passport, this.fieldValues.investor_data[1].passport_path);
        formData.append('file3', this.fieldValues.investor_data[1].signature, this.fieldValues.investor_data[1].signature_path);
        this.fieldValues.documents.forEach((doc, i) => {
            formData.append(`file${i + 4}`, doc.file, doc.path);
        });
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        await api.post(`/forms/joint/upload`, formData, config,)
            .then(res => {
                console.log("Image uploaded successfully");
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });

        this.sendJForm();
    }

    sendJForm() {

        api.post(`/forms/joint`, this.fieldValues)
            .then(res => {
                toast.success("Thanks for taking time to submit your details, we will contact you via email.");
                this.props.history.push(`/`)
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });
    }

    render() {
        switch (this.state.step) {
            case 1:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><InvestorsData fieldValues={this.fieldValues.investor_data[0]}
                    nextStep={this.nextStep}
                    saveValues={this.saveValues} /></section>
            case 2:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><OtherInfo fieldValues={this.fieldValues.other_info[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 3:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><NextOfKin fieldValues={this.fieldValues.next_of_kin[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 4:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><EmploymentDetails fieldValues={this.fieldValues.employment_details[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 5:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><IDMeans fieldValues={this.fieldValues.id_means[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 6:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><InvestorsData1 fieldValues={this.fieldValues.investor_data[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 7:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><OtherInfo1 fieldValues={this.fieldValues.other_info[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 8:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><NextOfKin1 fieldValues={this.fieldValues.next_of_kin[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 9:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><EmploymentDetails1 fieldValues={this.fieldValues.employment_details[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 10:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><IDMeans1 fieldValues={this.fieldValues.id_means[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 11:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><BankDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 12:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><InvestmentDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 13:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><GuarantorAccount fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 14:
                return <section><Header name="Joint Account Opening Form" step={this.state.step} max="14"/><Confirmation fieldValues={this.fieldValues}
                    submit={this.onSubmit}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            default:

        }
    }
}